import msgMappings from '~/assets/data/funnel-warning-msg-mappings.json';
import DisclosureFooter from '~/components/members-area/DisclosureFooter.vue';
export default {
  name: 'FunnelWarning',
  components: {
    DisclosureFooter
  },
  props: {
    warningContext: {
      type: Object
    },
    planPrice: {
      type: Number,
      default: 0
    },
    isDev: {
      type: Boolean,
      required: false
    }
  },
  emits: ['form-fill-retry', 'retry-plaid', 'change-plan'],
  data() {
    var _this$warningContext;
    return {
      Messages: msgMappings[(_this$warningContext = this.warningContext) === null || _this$warningContext === void 0 ? void 0 : _this$warningContext.context],
      buttonClasses: 'button--white first:button--filled shrink-0 h-12 sm:w-full',
      formFillRetryButton: false,
      retryPlaidButton: false,
      changePlanButton: false,
      devOnlyButton: false
    };
  },
  computed: {
    Body() {
      var _this$Messages;
      return (_this$Messages = this.Messages) === null || _this$Messages === void 0 || (_this$Messages = _this$Messages.body) === null || _this$Messages === void 0 ? void 0 : _this$Messages.replaceAll('{{planPrice}}', this.planPrice);
    }
  },
  mounted() {
    var _this$warningContext2, _this$warningContext3, _this$Messages$button;
    this.$analyticsHub.track(`Warning.funnel.${(_this$warningContext2 = this.warningContext) === null || _this$warningContext2 === void 0 ? void 0 : _this$warningContext2.context}`, {
      ...((_this$warningContext3 = this.warningContext) !== null && _this$warningContext3 !== void 0 && _this$warningContext3.details ? this.warningContext.details : {})
    });
    (_this$Messages$button = this.Messages.buttons) === null || _this$Messages$button === void 0 || _this$Messages$button.forEach(button => {
      switch (button) {
        case 'form_fill_retry':
          this.formFillRetryButton = true;
          break;
        case 'retry_plaid':
          this.retryPlaidButton = true;
          break;
        case 'change_plan':
          this.changePlanButton = true;
          break;
        default:
          console.warn('Are you missing a button?', button);
      }
    });
  }
};